export const enum IconCategory {
  Error = "error",
  Status = "status",
  General = "general",
  FileCommands = "fileCommands",
  Loaders = "loaders",
  Fields = "fields",
  Soma = "soma",
  Auxiliaries = "auxiliaries",
  Reason = "reason",
  ScheduleCommand = "scheduleCommand",
  DiffuseOptimization = "diffuseOptimization",
  SafetyReason = "safetyReason",
  Grid = "grid",
  LossAnalysis = "lossAnalysis",
}

export const enum ErrorIcons {
  DataPointError = "DataPointError",
  HighSeverityError = "HighSeverityError",
  MildSeverityError = "MildSeverityError",
  LowSeverityError = "LowSeverityError",
  UndefinedSeverityError = "UndefinedSeverityError",
  MultisiteHighSeverityError = "MultisiteHighSeverityError",
  MultisiteMildSeverityError = "MultisiteMildSeverityError",
  MultisiteLowSeverityError = "MultisiteLowSeverityError",

  MultisiteUndefinedError = "MultisiteUndefinedSeverityError",
  EmergencyError = "EmergencyError",
  EmergencyErrorHover = "EmergencyErrorHover",
}

export const enum AuxiliariesStatusIcons {
  Battery = "Battery",
  BatteryInvalid = "BatteryInvalid",
  Inverter = "Inverter",
  InverterInvalid = "InverterInvalid",
  Grid = "Grid",
  GridInvalid = "GridInvalid",
  Tracker = "Tracker",
  TrackerInvalid = "TrackerInvalid",
  StatusMark = "StatusMark",
  Ok = "Ok",
  Warning = "Warning",
  Error = "Error",
  Undefined = "Undefined",
}

export const enum GeneralIcons {
  UserRecords = "UserRecords",
  UserRecordsDisabled = "UserRecordsDisabled",
  SolarGikLogo = "SolarGikLogo",
  HeaderSolargikLogo = "HeaderSolargikLogo",
  UserIcon = "UserIcon",
  Separator = "Separator",
  TrackerBattery = "TrackerBattery",
  SafeOverridePopUp = "SafeOverridePopUp",
}

export const enum FileCommandsIcons {
  Download = "Download",
  WhiteDownload = "WhiteDownload",
  DownloadDisabled = "DownloadDisabled",
  Upload = "Upload",
  WhiteUpload = "WhiteUpload",
  UploadDisabled = "UploadDisabled",
  Delete = "Delete",

  DeleteDisabled = "DeleteDisabled",

  Send = "Send",
  WhiteSend = "WhiteSend",
  Close = "Close",
}

export const enum LoadersIcons {
  ChartLoader = "ChartLoader",
  ChartCardSkeleton = "ChartCardSkeleton",
  TrackerStatesSkeleton = "TrackerStatesSkeleton",
  WindChartSkeleton = "WindChartSkeleton",
  ProductionVsIrradianceSkeleton = "ProductionVsIrradianceSkeleton",
  InverterPerformanceChartSkeleton = "InverterPerformanceSkeleton",
  TopIssueSkeleton = "TopIssueSkeleton",
  CumulativeProductionChartSkeleton = "CumulativeProductionSkeleton",
}

export const enum FieldIcons {
  ArrowDown = "ArrowDown",
  ArrowDownDisabled = "ArrowDownDisabled",
  FocusedArrowDown = "FocusedArrowDown",
  RightArrow = "RightArrow",
  Calender = "Calender",
  ListItemSelected = "ListItemSelected",
}

export const enum SomaIcons {
  ACPower = "ACPower",
  ACPowerInvalid = "ACPowerInvalid",
  PlantGrowth = "PlantGrowth",
  PlantGrowthInvalid = "PlantGrowthInvalid",
  Photosyn = "Photosyn",
  PhotosynInvalid = "PhotosynInvalid",
  RainGouge = "RainGouge",
  RainGougeInvalid = "RainGougeInvalid",
  BarometricPressure = "BarometricPressure",
  BarometricPressureInvalid = "BarometricPressureInvalid",
  ClosedEye = "ClosedEye",
  OpenedEye = "OpenedEye",
  Plus = "Plus",
  EditLine = "EditLine",
  Shading025 = "Shading025",
  Shading2550 = "Shading2550",
  Shading5075 = "Shading5075",
  Shading75100 = "Shading75100",
  Connector = "Connector",
  Clock = "Clock",
  SprinklerOn = "SprinklerOn",
  SprinklerOff = "SprinklerOff",
  AlertMuted = "AlertMuted",
  AlertUnmuted = "AlertUnmuted",
  NoIssues = "NoIssues",
  TopIssuesServerErrorIcon = "TopIssuesServerErrorIcon",
}

export const enum AuxiliariesIcons {
  Inverter = "Inverter",
  Tracker = "Tracker",
}

export const enum ReasonIcons {
  Wind = "Wind",
  Snow = "Snow",
  Sprinklers = "Sprinklers",
  Tracker = "Tracker",
  Maintenance = "Maintenance",
  Software = "Software",
  Ups = "Ups",
  User = "User",
  Engineer = "Engineer",
  WindForecastSafety = "WindForecastSafety",
  SnowForecastSafety = "SnowForecastSafety",
}

export const enum ScheduleCommandIcons {
  ExistsScheduledCommand = "ExistsScheduledCommand",
  Recurrence = "Recurrence",
  ActiveScheduledCommand = "ActiveScheduledCommand",
}

export const enum DiffuseOptimizationIcons {
  DiffuseOptimizationOn = "DiffuseOptimizationOn",
}

export const enum GridIcons {
  Delete = "Delete",
  Edit = "Edit",
}

export const enum LossAnalysisIcons {
  AvailableSolarEnergy = "AvailableSolarEnergy",
  ActualProduction = "ActualProduction",
  Losses = "Losses",
  EmptyState = "EmptyState",
}
